/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.CallLogFilter = (function() {

    /**
     * Namespace CallLogFilter.
     * @exports CallLogFilter
     * @namespace
     */
    var CallLogFilter = {};

    CallLogFilter.CallLogFilterModel = (function() {

        /**
         * Properties of a CallLogFilterModel.
         * @memberof CallLogFilter
         * @interface ICallLogFilterModel
         * @property {number|null} [subscriptionId] CallLogFilterModel subscriptionId
         * @property {string|null} [query] CallLogFilterModel query
         * @property {string|null} [sortBy] CallLogFilterModel sortBy
         * @property {string|null} [sortOrder] CallLogFilterModel sortOrder
         * @property {number|null} [pageSize] CallLogFilterModel pageSize
         * @property {number|null} [pageIndex] CallLogFilterModel pageIndex
         */

        /**
         * Constructs a new CallLogFilterModel.
         * @memberof CallLogFilter
         * @classdesc Represents a CallLogFilterModel.
         * @implements ICallLogFilterModel
         * @constructor
         * @param {CallLogFilter.ICallLogFilterModel=} [p] Properties to set
         */
        function CallLogFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CallLogFilterModel subscriptionId.
         * @member {number|null|undefined} subscriptionId
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        CallLogFilterModel.prototype.subscriptionId = null;

        /**
         * CallLogFilterModel query.
         * @member {string|null|undefined} query
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        CallLogFilterModel.prototype.query = null;

        /**
         * CallLogFilterModel sortBy.
         * @member {string|null|undefined} sortBy
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        CallLogFilterModel.prototype.sortBy = null;

        /**
         * CallLogFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        CallLogFilterModel.prototype.sortOrder = null;

        /**
         * CallLogFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        CallLogFilterModel.prototype.pageSize = null;

        /**
         * CallLogFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        CallLogFilterModel.prototype.pageIndex = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * CallLogFilterModel _subscriptionId.
         * @member {"subscriptionId"|undefined} _subscriptionId
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        Object.defineProperty(CallLogFilterModel.prototype, "_subscriptionId", {
            get: $util.oneOfGetter($oneOfFields = ["subscriptionId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CallLogFilterModel _query.
         * @member {"query"|undefined} _query
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        Object.defineProperty(CallLogFilterModel.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CallLogFilterModel _sortBy.
         * @member {"sortBy"|undefined} _sortBy
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        Object.defineProperty(CallLogFilterModel.prototype, "_sortBy", {
            get: $util.oneOfGetter($oneOfFields = ["sortBy"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CallLogFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        Object.defineProperty(CallLogFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CallLogFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        Object.defineProperty(CallLogFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CallLogFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof CallLogFilter.CallLogFilterModel
         * @instance
         */
        Object.defineProperty(CallLogFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified CallLogFilterModel message. Does not implicitly {@link CallLogFilter.CallLogFilterModel.verify|verify} messages.
         * @function encode
         * @memberof CallLogFilter.CallLogFilterModel
         * @static
         * @param {CallLogFilter.ICallLogFilterModel} m CallLogFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallLogFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.subscriptionId != null && Object.hasOwnProperty.call(m, "subscriptionId"))
                w.uint32(8).int32(m.subscriptionId);
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(18).string(m.query);
            if (m.sortBy != null && Object.hasOwnProperty.call(m, "sortBy"))
                w.uint32(26).string(m.sortBy);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(40).int32(m.pageSize);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(48).int32(m.pageIndex);
            return w;
        };

        /**
         * Encodes the specified CallLogFilterModel message, length delimited. Does not implicitly {@link CallLogFilter.CallLogFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof CallLogFilter.CallLogFilterModel
         * @static
         * @param {CallLogFilter.ICallLogFilterModel} message CallLogFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallLogFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CallLogFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof CallLogFilter.CallLogFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {CallLogFilter.CallLogFilterModel} CallLogFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallLogFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.CallLogFilter.CallLogFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.subscriptionId = r.int32();
                    break;
                case 2:
                    m.query = r.string();
                    break;
                case 3:
                    m.sortBy = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageSize = r.int32();
                    break;
                case 6:
                    m.pageIndex = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a CallLogFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof CallLogFilter.CallLogFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {CallLogFilter.CallLogFilterModel} CallLogFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallLogFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return CallLogFilterModel;
    })();

    return CallLogFilter;
})();

module.exports = $root;
